module.exports = __webpack_public_path__ + "img/icon_dragdrop_en.8593689.svg";